import { useIdleTimer } from 'react-idle-timer';
import { useEffect } from 'react';
import { extendSession } from '@/services/auth/auth-service';

export function useExtendSession(prompted = false) {
  const idleTimer = useIdleTimer({
    throttle: 500,
  });
  const timeoutThreshold = 1000 * 60 * 30;
  const checkIdleInterval = 1000 * 60 * 30;

  useEffect(() => {
    const interval = setInterval(() => {
      const lastActiveTime = idleTimer.getLastActiveTime()?.getTime();
      if (
        lastActiveTime &&
        Date.now() - lastActiveTime < timeoutThreshold &&
        !prompted
      ) {
        extendSession().catch((error) => {
          console.error(error);
        });
      }
    }, checkIdleInterval);
    return () => {
      clearInterval(interval);
    };
  }, [checkIdleInterval, idleTimer, timeoutThreshold, prompted]);
}
